async function getUser() {
    return JSON.parse(localStorage.getItem("user-info"));
}

/**
 * Returns the primary user ID (IES id) for saving new progress.
 */
export async function getUserId() {
    const userData = await getUser();
    if (!userData) return null;
    return userData.id;
}

/**
 * Returns all known user IDs (IES + Sponte + Wizme) for reading progress.
 * The primary ID comes first. Duplicates are removed.
 * Includes ALL Sponte alunoIds (active + inactive) when available, so that
 * progress stored before a unit transfer or credential unification can be found.
 */
export async function getAllUserIds() {
    var userData = await getUser();
    if (!userData) return [];

    var ids = [];
    // Primary: IES id
    if (userData.id) ids.push(String(userData.id));

    // Secondary: all Sponte alunoIds (may be at root or inside .data)
    var sponteIds = (userData.data && userData.data.sponteIds) || userData.sponteIds;
    if (Array.isArray(sponteIds)) {
        sponteIds.forEach(function(id) {
            if (id && ids.indexOf(String(id)) === -1) ids.push(String(id));
        });
    } else {
        // Fallback to single sponteId for legacy user-info entries
        var sponteId = userData.sponteId || (userData.data && userData.data.sponteId);
        if (sponteId && ids.indexOf(String(sponteId)) === -1) {
            ids.push(String(sponteId));
        }
    }

    return ids;
}

export async function getUserEmail() {
    const userData = await getUser();
    return userData ? userData.email : null;
}

/**
 * Returns the student's Wizme platformId.
 * This ID is the foreign key used to link the student across Catchup data stores (Dynamo progress).
 */
export async function getWizmeId() {
    const userData = await getUser();
    if (!userData) return null;
    return userData.wizmeId || (userData.data && userData.data.wizmeId) || null;
}

/**
 * Returns the Portal enrollmentId carried by the Headless JWT (enrollment_id claim).
 */
export async function getEnrollmentId() {
    const userData = await getUser();
    if (!userData) return null;
    return userData.enrollment_id || null;
}

/**
 * Returns the Portal learningObjectId only for the lesson the Headless JWT was issued for,
 * so navigating to another lesson in the same session never reuses it.
 */
export async function getLearningObjectIdForLesson(lessonId) {
    const userData = await getUser();
    if (!userData || !userData.learning_object_id) return null;
    if (userData.lesson_id == null || Number(userData.lesson_id) !== Number(lessonId)) return null;
    return userData.learning_object_id;
}